var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "table",
    { staticClass: "hits-table", class: { parallel: _vm.isParallel } },
    [
      _c("thead", [
        _c(
          "tr",
          { staticClass: "rounded" },
          [
            _vm.isParallel
              ? _c("th", [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.$t("results.table.parallelVersion")) +
                      "\n\t\t\t"
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.columns, function (def) {
              return _c(
                "th",
                { key: def.key, class: def.textAlignClass },
                [
                  def.sortOptions.length > 1
                    ? _c("span", { staticClass: "dropdown" }, [
                        _c(
                          "a",
                          {
                            class: [
                              "dropdown-toggle",
                              { disabled: _vm.disabled },
                            ],
                            attrs: {
                              role: "button",
                              "data-toggle": "dropdown",
                            },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(def.columnLabel) +
                                "\n\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "caret" }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "dropdown-menu",
                            attrs: { role: "menu" },
                          },
                          _vm._l(def.sortOptions, function (o) {
                            return _c(
                              "li",
                              {
                                key: o.sortKey,
                                class: { disabled: _vm.disabled },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    class: ["sort", { disabled: _vm.disabled }],
                                    attrs: { role: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeSort(o.sortKey)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(_vm._s(o.label) + " "),
                                    _c("Debug", [_vm._v(_vm._s(o.debugLabel))]),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    : def.sortOptions.length === 1
                    ? _c(
                        "a",
                        {
                          class: ["sort", { disabled: _vm.disabled }],
                          attrs: {
                            role: "button",
                            title: def.sortOptions[0].title.toString(),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeSort(def.sortOptions[0].sortKey)
                            },
                          },
                        },
                        [
                          _vm._v(_vm._s(def.columnLabel) + " "),
                          _c("Debug", [
                            _vm._v(_vm._s(def.sortOptions[0].debugLabel)),
                          ]),
                        ],
                        1
                      )
                    : [_vm._v(_vm._s(def.columnLabel))],
                ],
                2
              )
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.data, function (h, i) {
        return [
          h.type === "hit"
            ? _c("Hit", {
                attrs: {
                  query: _vm.query,
                  mainAnnotation: _vm.mainAnnotation,
                  otherAnnotations: _vm.otherAnnotations,
                  detailedAnnotations: _vm.detailedAnnotations,
                  depTreeAnnotations: _vm.depTreeAnnotations,
                  metadata: _vm.metadata,
                  dir: _vm.hitDirection(h),
                  html: _vm.html,
                  disabled: _vm.disabled,
                  disableDetails: _vm.disableDetails,
                  h: h,
                  isParallel: _vm.isParallel,
                },
              })
            : _c("DocRow", {
                key: `${i}-doc`,
                attrs: {
                  data: h,
                  metadata: _vm.metadata,
                  colspan: _vm.colspan,
                },
              }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }